export const ME_ENDPOINT_STALE_TIME_IN_MS = 1000 * 60 * 60 * 5; // 5 hours
